import { Card, Grid } from "@mui/material";
import Loading from "../../load/loading";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import { useEffect, useState } from "react";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import FotoEdit from "../../utils/fotoEdit";
import Delete from "../../utils/delete";
import DirectorTecnicoCreateRepresentante from "./directorTecnicoCreateRepresentante";
import InfoFieldGroup from "../../utils/InfoField/InfoFieldGroup";
import apiCNP from "../../services/apiCNP";
import { useSelector } from "react-redux";
import api from "../../services/api";


export default function FichaDirectorTecnico({ directorTecnico, header, menu, setRefresh }) {
    const user = useSelector(state => state.account.user);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [editDados, setEditDados] = useState('')
    const [isEdit, setIsEdit] = useState(false)
    const [openEditFoto, setOpenEditFoto] = useState(false)
    const [open, setOpen] = useState(false);
    const [openDTCR, setOpenDTCR] = useState(false);
    // console.log(directorTecnico)
    const [municipios, setMunicipios] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [categoria, setCategoria] = useState([]);

    useEffect(() => {
        if (isEdit) {
            apiCNP.get('/provincias')
                .then(res => {
                    setProvincias(res.data.provincias);

                }).catch(err => '')

            api.get('/categoria-tecnico')
                .then(res => {
                    setCategoria(res.data.categoriaTecnicos);
                })
                .catch(err => '')
        }
    }, [isEdit])

    useEffect(() => {
        if (editDados?.provinciaId) {
            apiCNP.get(`/municipios-by-provincia/${editDados?.provinciaId}`)
                .then(res => {
                    setMunicipios(res.data.municipios);
                    setEditDados((prev) => ({ ...prev, provincia: res.data.provincia.designacao }));
                }).catch(err => 'console.log(err)')
        }
    }, [editDados?.provinciaId])

    const submitEdit = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(editDados)

        await api.put('/dados-pessoais/edit', { ...editDados, dadosPessoaisId: directorTecnico?.dadosPessoais?._id, 'userId': user?._id ?? '' })
            .then(res => {
                setMessageSuccess(res.data.msg)
                // setDadosPessoais(res.data)
                setRefresh && setRefresh(res.data)
                setOpen(false)
                setIsEdit(false)

            }).catch(err => {
                setOpen(false)
                setMessageError(err.response.data.message)
            })
    }


    const submitEditDT = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        await api.put('/director-tecnico/edit', { ...editDados, 'directorTecnicoId': directorTecnico._id, 'userId': user?._id ?? '' })
            .then(res => {
                // setDadosDirectorTecnico(res.data.directorTecnico)
                setRefresh && setRefresh(res.data)
                setOpen(false)
                setMessageSuccess(res.data.msg)
                setIsEdit(false)

            }).catch(err => {
                // console.log(err)
                setOpen(false)
                setMessageError(err.response.data.message)
            })
    }

    return (directorTecnico ?

        <Card style={{ padding: 20, minHeight: '20vh', marginTop: 20 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <Delete
                // open={open}
                setOpen={setOpen}
                url={'/director-tecnico/delete'}
                msg={`Tem certeza que deseja eliminar Director(a) Técnico(a) ${directorTecnico?.dadosPessoais?.nome}`}
                id={directorTecnico._id}
            />

            <DirectorTecnicoCreateRepresentante
                open={openDTCR}
                setOpen={setOpenDTCR}
                directorTecnico={directorTecnico}
            />

            {header &&
                <HeaderGestorConfigs
                    menu={menu ?? true}
                    configArea={'fichaDT'}
                    title={isEdit ? 'EDITAR DADOS' : 'FICHA DE DIRECTOR TÉCNICO'}
                    directorTecnico={directorTecnico}
                    editDados={isEdit}
                    setEditDados={setIsEdit}
                    directorTecnicoCreateRepresentante={setOpenDTCR}
                    delete={setOpen}
                />
            }

            <Grid container>
                {!isEdit &&
                    <Grid item marginRight={2}>
                        <FotoEdit
                            openEditFoto={openEditFoto}
                            setOpenEditFoto={setOpenEditFoto}
                            dadosPessoal={directorTecnico?.dadosPessoais}
                        />
                    </Grid>
                }

                {isEdit !== 'dadosdirectortecnicoedit' &&
                    <Grid xs item >
                        <InfoFieldGroup
                            submit={submitEdit}
                            data={editDados}
                            // handleChange={handleChange}
                            setIsEdit={setIsEdit}
                            isEdit={isEdit}
                            load={open}
                            fields={
                                [
                                    // { label: 'Estado', value: directorTecnico?.status, editable: false, },
                                    { label: 'Nome', value: directorTecnico?.dadosPessoais?.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, nome: v.target.value }) },
                                    { label: 'B.I', value: directorTecnico?.dadosPessoais?.numeroBI, key: 'numeroBI', onChange: (v) => setEditDados({ ...editDados, numeroBI: v.target.value }) },
                                    { label: 'Carteira', value: directorTecnico?.numeroCarteira, key: 'numeroCarteira', onChange: (v) => setEditDados({ ...editDados, numeroCarteira: v.target.value }), editable: false },
                                    { label: 'Categoria', value: directorTecnico?.categoria?.designacao, key: 'categoriaId', type: 'select', options: categoria, onChange: (v) => setEditDados({ ...editDados, categoriaId: v.target.value }), editable: false },
                                    { label: 'Ordem', value: directorTecnico?.ordem, key: 'ordem', onChange: (v) => setEditDados({ ...editDados, ordem: v.target.value }), editable: false },
                                    { label: 'Carteira', value: directorTecnico?.numeroCarteira, key: 'numeroCarteira', onChange: (v) => setEditDados({ ...editDados, numeroCarteira: v.target.value }) },
                                    { label: 'E-mail', value: directorTecnico?.dadosPessoais?.email, key: 'email', onChange: (v) => setEditDados({ ...editDados, email: v.target.value }) },
                                    { label: 'Telefone 1', value: directorTecnico?.dadosPessoais?.tel1, key: 'tel1', onChange: (v) => setEditDados({ ...editDados, tel1: v.target.value }) },
                                    { label: 'Telefone 2', value: directorTecnico?.dadosPessoais?.tel2 ?? '', key: 'tel2', onChange: (v) => setEditDados({ ...editDados, tel2: v.target.value }) },
                                    { label: 'Província', value: directorTecnico?.dadosPessoais?.provincia, key: 'provinciaId', type: 'select', options: provincias, onChange: (v) => setEditDados({ ...editDados, provinciaId: v.target.value }) },
                                    { label: 'Município', value: directorTecnico?.dadosPessoais?.municipio, key: 'municipio', type: 'select', options: municipios, onChange: (v) => setEditDados({ ...editDados, municipio: v.target.value }) },
                                    { label: 'Bairro', value: directorTecnico?.dadosPessoais?.bairro, key: 'bairro', onChange: (v) => setEditDados({ ...editDados, bairro: v.target.value }) },
                                    { label: 'Rua / Avenida', value: directorTecnico?.dadosPessoais?.rua, key: 'rua', onChange: (v) => setEditDados({ ...editDados, rua: v.target.value }) },
                                    { label: 'Nacionalidade', value: directorTecnico?.dadosPessoais?.nacionalidade, key: 'nacionalidade', onChange: (v) => setEditDados({ ...editDados, nacionalidade: v.target.value }) },
                                ]
                            } />
                    </Grid>
                }
            </Grid>

            {(isEdit === 'dadosdirectortecnicoedit' || editDados === 'all') &&

                <InfoFieldGroup
                    submit={submitEditDT}
                    data={editDados}
                    // handleChange={handleChange}
                    setIsEdit={setIsEdit}
                    isEdit={isEdit}
                    load={open}
                    fields={
                        [
                            { label: 'Número de Carteira', value: directorTecnico?.numeroCarteira, key: 'numeroCarteira', onChange: (v) => setEditDados({ ...editDados, numeroCarteira: v.target.value }) },
                            { label: 'Categoria', value: directorTecnico?.categoria?.designacao, key: 'categoriaId', type: 'select', options: categoria, onChange: (v) => setEditDados({ ...editDados, categoriaId: v.target.value }) },
                            { label: 'Ordem', value: directorTecnico?.ordem, key: 'ordem', onChange: (v) => setEditDados({ ...editDados, ordem: v.target.value }) },
                        ]
                    } />
            }
        </Card>
        :
        <Loading />
    )
}